import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String
  }

  connect() {
    this.originalText = this.element.innerText
  }

  toggle(event) {
    if (this.isExporting) return

    const downloadId = Date.now().toString()
    const url = new URL(this.element.href)
    url.searchParams.set("download_id", downloadId)
    this.element.href = url.toString()

    this.isExporting = true
    if (this.hasTextValue) {
      this.element.innerText = this.textValue
    }
    this.element.classList.add("pointer-events-none", "opacity-50")

    this.checkDownloadStatus(downloadId)
  }

  checkDownloadStatus(downloadId) {
    this.timer = setInterval(() => {
      if (this.getCookie("download_id") === downloadId) {
        this.reset()
      }
    }, 1000)
  }

  reset() {
    clearInterval(this.timer)
    this.deleteCookie("download_id")
    this.element.innerText = this.originalText
    this.element.classList.remove("pointer-events-none", "opacity-50")
    this.isExporting = false
  }

  getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(";").shift()
  }

  deleteCookie(name) {
    document.cookie = `${name}=; Max-Age=-99999999; path=/;`
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }
}
